module.exports = __webpack_public_path__ + "img/avatar5.aaf49a31.png";